import e from "./Loader.module.js";
import "react";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region lib/components/Loader/Loader.tsx
function r({ size: r = "sm", centered: i = !1, color: a = "var(--ag-neutral-solid-default)", ...o }) {
	return /* @__PURE__ */ t("div", {
		...o,
		className: `${e.loader} ${e[r]} ${o.className ?? ""} ${i ? e.centered : ""}`,
		style: {
			...o.style,
			"--ag-loader-color": a
		},
		children: /* @__PURE__ */ n("div", { children: [
			/* @__PURE__ */ t("div", {}),
			/* @__PURE__ */ t("div", {}),
			/* @__PURE__ */ t("div", {}),
			/* @__PURE__ */ t("div", {})
		] })
	});
}
//#endregion
export { r as Loader };
